import { render } from "./RegisterPatient.vue?vue&type=template&id=db4dd6d4"
import script from "./RegisterPatient.vue?vue&type=script&lang=js"
export * from "./RegisterPatient.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__